// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"131":"eecd8a25db519c2bebbc","152":"b143189713ce2588f73a","196":"e4f434535bae6163a5eb","862":"69d36afabceb8635ab27"}[chunkId] + ".js";
};